import { render, staticRenderFns } from "./BalanceStatement.vue?vue&type=template&id=25186bb0&scoped=true"
import script from "./BalanceStatement.vue?vue&type=script&lang=js"
export * from "./BalanceStatement.vue?vue&type=script&lang=js"
import style0 from "./BalanceStatement.vue?vue&type=style&index=0&id=25186bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25186bb0",
  null
  
)

export default component.exports